// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SectionContainer, SectionTitle } from "@conklin/App/Widgets/DesignSystem/DesignSystem.helpers";
import DummyPaginatedTable from "@conklin/App/Widgets/DesignSystem/DummyData/DummyPaginationTable";
import translate from "@insite/client-framework/Translate";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import React, { FC } from "react";
import { css } from "styled-components";

interface PaginationTabStyles {
    titleGridItem?: GridItemProps;
    gridItem?: GridItemProps;
}

const paginationTabStyles: PaginationTabStyles = {
    titleGridItem: {
        width: 12,
    },
    gridItem: {
        width: 12,
        css: css`
            flex-wrap: wrap;
            padding-bottom: 40px;
        `,
    },
};

const styles = paginationTabStyles;
const PaginationTab: FC = props => {
    return (
        <SectionContainer>
            <GridItem {...styles.titleGridItem}>
                <SectionTitle>{translate("Pagination")}</SectionTitle>
            </GridItem>
            <GridItem {...styles.gridItem}>
                <DummyPaginatedTable />
            </GridItem>
        </SectionContainer>
    );
};

export default PaginationTab;
